import React from "react";
import { Phone, Mail, Building2 } from "lucide-react";
import { BRAND } from "@/data/content";
import { LeadForm } from "@/components/site/consultation";
import { Reveal } from "@/components/site/reveal";

export default function ContactFooter() {
  return (
    <>
      <section id="contact" className="relative overflow-hidden bg-navy py-24 md:py-32 grain" data-testid="contact-section">
        <div className="mx-auto grid max-w-7xl gap-16 px-6 lg:grid-cols-2 lg:px-10">
          <div>
            <Reveal><p className="text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">Get Started</p></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-5 font-serif text-4xl leading-[1.05] text-white sm:text-5xl md:text-6xl">
                Let Us Maximise<br />Your Property&rsquo;s<br /><span className="italic text-gold">Potential.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-md text-base leading-relaxed text-white/60">
                Book a free, no-obligation consultation. Tell us about your property and we&rsquo;ll
                recommend the right level of management for you.
              </p>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-12 space-y-5 border-t border-white/10 pt-10">
                <div className="flex items-center gap-4 text-white/80" data-testid="contact-business">
                  <Building2 className="h-5 w-5 text-gold" />
                  <span>{BRAND.name}</span>
                </div>
                <a href={`mailto:${BRAND.email}`} className="flex items-center gap-4 text-white/80 transition-colors hover:text-gold" data-testid="contact-email">
                  <Mail className="h-5 w-5 text-gold" />
                  <span>{BRAND.email}</span>
                </a>
                <a href={BRAND.phoneHref} className="flex items-center gap-4 text-white/80 transition-colors hover:text-gold" data-testid="contact-phone">
                  <Phone className="h-5 w-5 text-gold" />
                  <span className="font-serif text-2xl">{BRAND.phone}</span>
                </a>
              </div>
            </Reveal>
          </div>

          <Reveal delay={0.1}>
            <div className="bg-white/5 p-8 backdrop-blur-xl ring-1 ring-inset ring-white/10 sm:p-10">
              <p className="mb-8 text-[11px] uppercase tracking-[0.3em] text-gold font-semibold">Request a Quote</p>
              <LeadForm dark />
            </div>
          </Reveal>
        </div>
      </section>

      <footer className="bg-navy border-t border-white/10 py-10" data-testid="site-footer">
        <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-6 text-center sm:flex-row sm:text-left lg:px-10">
          <div className="flex flex-col leading-none">
            <span className="font-serif text-xl text-white">First<span className="text-gold"> Impression</span></span>
            <span className="mt-1 text-[9px] uppercase tracking-[0.35em] text-white/40">{BRAND.tagline}</span>
          </div>
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} {BRAND.name}. All rights reserved.
          </p>
        </div>
      </footer>
    </>
  );
}
